import { UserInterface, UserVarsMap } from "@swivl-mono/types";
import { useMemo } from "react";

import { UserDetailsEditBasicInfoView } from "../Components/UserDetails.EditBasicInfo";
import { UserDetailsUserVarsComponent } from "../Components/UserDetails.UserVars";

interface EditCustomerDetailsProps {
  isPanelOpen: boolean;
  user: UserInterface;
  userVars: UserVarsMap | undefined;
}

const topLevelKeys = [
  "name",
  "phoneNumber",
  "email",
  "locationId",
  "postalCode"
  // "FilterSize",
  // "FilterFeatures",
  // "Location",
  // "EmailType",
];

export type TopLevelKey = (typeof topLevelKeys)[number];

export default function UserDetailsEditCustomerDetailsView({ user, userVars }: EditCustomerDetailsProps) {
  const { otherVars } = useMemo(() => {
    const topLevelVars: UserVarsMap = {};
    const otherVars: UserVarsMap = {};

    if (userVars) {
      for (const [userVarKey, value] of Object.entries(userVars)) {
        if (topLevelKeys.includes(userVarKey as TopLevelKey)) {
          topLevelVars[userVarKey as TopLevelKey] = value;
        } else {
          otherVars[userVarKey as TopLevelKey] = value;
        }
      }
    }

    if (user) {
      for (const [userKey, value] of Object.entries(user)) {
        if (topLevelKeys.includes(userKey as TopLevelKey)) {
          topLevelVars[userKey as TopLevelKey] = value;
        } else {
          otherVars[userKey as TopLevelKey] = value;
        }
      }
    }

    return { topLevelVars, otherVars };
  }, [userVars, user]);

  return (
    <div className="flex flex-col gap-2 pb-6" key={"edit" + user.id}>
      <UserDetailsEditBasicInfoView user={user} />
      <UserDetailsUserVarsComponent user={user} userVars={otherVars} />
    </div>
  );
}
